<div class="col layout-row"
     [ngClass]="{'selected': isSelected, 'locked': route.locked || isRunning, 'full-height': !isCollapsed, 'collapsed': isCollapsed}"
     (mouseenter)="onHover(true)"
     (mouseleave)="onHover(false)"
     (contextmenu)="onContextMenu($event)"
     (click)="onDrillDownClick($event)">

  <div class="route-left-bar layout-column layout-align-center-center gap-5 padding-top-10 padding-bottom-10">
    <bringoz-button *ngIf="(route.locked || isHover) && !isCollapsed"
                    type="tertiary"
                    size="fit"
                    [ngbTooltip]="route.locked ? ('Unlock Route' | translate) : ('Lock Route' | translate)"
                    container="body"
                    openDelay="300"
                    (onClick)="onToggleLocked();$event.stopPropagation();">
      <bringoz-icon [iconName]="route.locked ? 'lock' : 'lock-open-outline'" classSize="lg"
                    fill="#484848"></bringoz-icon>
    </bringoz-button>
    <div class="index-border" [style.background-color]="routeColor"></div>
  </div>

  <div class="flex layout-row layout-wrap">

    <!--Link Row-->
    <div class="layout-row layout-align-start-center full-width">

<!--      &lt;!&ndash; Edit Resource Allocation Button &ndash;&gt;-->
<!--      <ng-container *ngIf="!canClose && !route.locked && route.status !== 'DISPATCHED'">-->
<!--        <bringoz-button type="tertiary"-->
<!--                        size="fit"-->
<!--                        class="edit-resource-btn"-->
<!--                        *ngxPermissionsOnly="'planning.update'"-->
<!--                        (onClick)="onEditResourceAllocation.emit({route, event: $event});$event.stopPropagation();"-->
<!--                        [ngbTooltip]="route.locked ? ('Route is locked for editing' | translate) : ('Edit Resource Allocation' | translate)">-->
<!--          <bringoz-icon iconName="edit-outline" classSize="sm" [fill]="route.locked ? '#CCCCCC' : '#484848'"></bringoz-icon>-->
<!--        </bringoz-button>-->
<!--      </ng-container>-->

      <div class="flex layout-row route-title">
        <app-bringoz-checkbox *ngIf="canSelect && route.status !== 'DISPATCHED'"
                              [isChecked]="isSelected"
                              (clickEvent)="onToggle.emit(!isSelected)">
        </app-bringoz-checkbox>
        <div class="flex layout-row clickable gap-5"
             (click)="onChangeRouteResource.emit({routeId: route.id, event: $event});$event.stopPropagation();">
          <span class="br-body-1">
            {{route.name || route.resource?.agentName}}
          </span>
<!--          <span id="route-resource-arrow">▾</span>-->
        </div>

        <div class="layout-row layout-align-start-center gap-2">
          <bringoz-icon iconName="account" classSize="sm" fill="#484848"></bringoz-icon>
          <span class="br-body-1">{{ accountIds.length }}</span>
        </div>
      </div>


      <div *ngIf="canClose" class="layout-column layout-align-center-center gap-0">
        <bringoz-button type="tertiary"
                        [ngbTooltip]="'Back'"
                        (onClick)="onClose.emit()">
          <bringoz-icon iconName="arrow-left" classSize="lg" fill="#484848"></bringoz-icon>
        </bringoz-button>
      </div>

    </div>

    <!--ID-->
    <div class="flex-100 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="hash"
                    classSize="sm">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ route.id }}</span>
    </div>

    <!--Time Window Row-->
    <div class="flex-100 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="time-window-outline"
                    classSize="sm">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ dateRange | timeWindow }}</span>
    </div>

    <!--Duration Row-->
    <div
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="timer-outline"
                    classSize="sm"
                    [ngbTooltip]="'Duration' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-task-detailed-service-time *ngIf="!!routeDetailedServiceTime"
                                      [fontSize]="'br-body-1'"
                                      [isAllowEdit]="false"
                                      [detailedServiceTime]="routeDetailedServiceTime">
      </app-task-detailed-service-time>
      <span class="br-body-1 text-ellipsis"
            [ngbTooltip]="distanceTooltip">
        {{ route.totals?.totalTimeSec | bringozTimeConvert }}
      </span>
      <ng-template #distanceTooltip>
        <div class="layout-column gap-5">
          <div class="layout-row layout-align-start-center">
            <span class="br-body-2 font-weight-600">{{ 'Travel Time' | translate }}:</span>
            <span class="br-body-2 font-weight-400 margin-left-5">
              {{ route.totals.totalTravelTimeSec * 1000 | serviceTime }}
            </span>
          </div>
          <div class="layout-row layout-align-start-center">
            <span class="br-body-2 font-weight-600">{{ 'Service Time' | translate }}:</span>
            <span class="br-body-2 font-weight-400 margin-left-5">
              {{ route.totals.totalServiceTimeSec * 1000 | serviceTime }}
            </span>
          </div>
          <div *ngIf="!!routeTotalIdleTime" class="layout-row layout-align-start-center">
            <span class="br-body-2 font-weight-600">{{ 'Idle Time' | translate }}:</span>
            <span class="br-body-2 font-weight-400 margin-left-5">
              {{ routeTotalIdleTime | serviceTime }}
            </span>
          </div>
        </div>
      </ng-template>
    </div>

    <!--Agent Row-->
    <div
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class=" layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="agent"
                    classSize="sm"
                    [ngbTooltip]="'Agent' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ route.resource?.agentName || '---' }}</span>
    </div>

    <!--Idle Time Row-->
    <div
      [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
      class=" layout-row info-row ">

      <div class="layout-row layout-align-start-center gap-5" [ngClass]="{'idle-time': !!routeTotalIdleTime}">
        <bringoz-icon iconName="hourglass"
                      classSize="sm"
                      [color]="!!routeTotalIdleTime ? '#F03E38' : ''"
                      [ngbTooltip]="'Idle Time' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ !!routeTotalIdleTime ? (routeTotalIdleTime | serviceTime) : '---' }}</span>
      </div>

    </div>

    <!--Branches Row-->
    <div
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class=" layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="branch"
                    classSize="sm"
                    [ngbTooltip]="'Branches' | translate"
                    openDelay="300">

      </bringoz-icon>
      <branches-indicator [branches]="route.resource?.branchReferences"></branches-indicator>
    </div>

<!--    &lt;!&ndash;Accounts Row&ndash;&gt;-->
<!--    <div [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"-->
<!--         class=" layout-row layout-align-start-center info-row gap-5 ">-->
<!--      <bringoz-icon iconName="account"-->
<!--                    classSize="sm"-->
<!--                    fill="#484848"-->
<!--                    [ngbTooltip]="'Accounts' | translate"-->
<!--                    openDelay="300">-->

<!--      </bringoz-icon>-->
<!--      <span class="br-body-1 text-ellipsis">{{accountIds.length === 1 ? ('X_ACCOUNT' | translate: {length: accountIds.length}) : ('X_ACCOUNTS' | translate: {length: accountIds.length}) }}</span>-->
<!--    </div>-->

    <!--Status Row-->
    <div
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class=" layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="status"
                    classSize="sm"
                    [ngbTooltip]="'Status' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-status-tag [status]="isRunning ? (route.actionProcess.isDispatching ? 'DISPATCHING' : 'OPTIMIZING') : route.status"></app-bringoz-status-tag>
    </div>

    <!--Skills Row-->
    <div
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class=" layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="tag-outline"
                    classSize="sm"
                    [ngbTooltip]="'Skills' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span *ngIf="!route.resource?.allocationSkills?.length" class="br-body-1 text-ellipsis">---</span>
      <app-skill-tags class="flex" [skillsIds]="routeSkills || route.resource?.allocationSkills" limit="1"></app-skill-tags>
    </div>


    <!--Total Delivery Units Row-->
    <div
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class=" layout-row layout-align-start-center info-row gap-5 ">
      <bringoz-icon iconName="package-outline"
                    classSize="sm"
                    [ngbTooltip]="'Total Delivery Units' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{totalDeliveryUnits}}</span>
    </div>

<!--    &lt;!&ndash;Labels Row&ndash;&gt;-->
<!--    <div-->
<!--         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"-->
<!--         class=" layout-row layout-align-start-center info-row gap-5 ">-->
<!--      <bringoz-icon iconName="label-outline"-->
<!--                    classSize="sm"-->
<!--                    fill="#484848"-->
<!--                    [ngbTooltip]="'Labels' | translate"-->
<!--                    openDelay="300">-->

<!--      </bringoz-icon>-->
<!--      <app-bringoz-labels-display *ngIf="!!route.resource?.labels?.length"-->
<!--                                  [labels]="route.resource.labels"-->
<!--                                  maxItems="1">-->

<!--      </app-bringoz-labels-display>-->
<!--      <span *ngIf="!route.resource?.labels?.length" class="br-body-1 text-ellipsis">-&#45;&#45;</span>-->
<!--    </div>-->

<!--    &lt;!&ndash;Vehicle Row&ndash;&gt;-->
<!--    <div-->
<!--         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"-->
<!--         class=" layout-row layout-align-start-center info-row gap-5 ">-->
<!--      <bringoz-icon [iconName]="route.resource?.vehicleClass?.toLowerCase()"-->
<!--                    [classSize]="'sm'"-->
<!--                    [ngbTooltip]="'Vehicle' | translate"-->
<!--                    openDelay="300">-->

<!--      </bringoz-icon>-->
<!--      <span class="br-body-1 text-ellipsis">{{ route.resource?.vehicleName }}</span>-->
<!--    </div>-->

<!--    &lt;!&ndash;Distance Row&ndash;&gt;-->
<!--    <div-->
<!--         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"-->
<!--         class=" layout-row layout-align-start-center info-row gap-5 ">-->
<!--      <bringoz-icon iconName="distance"-->
<!--                    [classSize]="'sm'"-->
<!--                    [ngbTooltip]="'Total Distance' | translate"-->
<!--                    openDelay="300">-->

<!--      </bringoz-icon>-->
<!--      <span class="br-body-1 text-ellipsis">{{ route.totals?.totalDistanceMeter | bringozDistance:'-&#45;&#45;':true }}</span>-->
<!--    </div>-->

<!--    &lt;!&ndash;Distance Row&ndash;&gt;-->
<!--    <div-->
<!--         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"-->
<!--         class=" layout-row layout-align-start-center info-row gap-5 ">-->
<!--      <bringoz-icon iconName="carrier"-->
<!--                    classSize="sm"-->
<!--                    fill="#484848"-->
<!--                    [ngbTooltip]="'Carrier' | translate"-->
<!--                    openDelay="300">-->

<!--      </bringoz-icon>-->
<!--      <app-bringoz-state-link *ngIf="!!route.resource?.carrierReference"-->
<!--                              class="flex text-ellipsis"-->
<!--                              [state]="'accounts-detail-supply.info.preferences'"-->
<!--                              [permission]="'accounts.supply.get'"-->
<!--                              [params]="{id: route.resource.carrierReference.id}"-->
<!--                              [text]="route.resource.carrierReference.name">-->
<!--      </app-bringoz-state-link>-->
<!--      <span *ngIf="!route.resource?.carrierReference" class="br-body-1 text-ellipsis">-&#45;&#45;</span>-->

<!--    </div>-->


<!--    &lt;!&ndash;Load - Weight&ndash;&gt;-->
<!--    <div-->
<!--         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"-->
<!--         class=" layout-row layout-align-start-center info-row gap-5 text-ellipsis ">-->
<!--      <bringoz-icon iconName="weight"-->
<!--                    classSize="sm"-->
<!--                    [ngbTooltip]="'Weight' | translate"-->
<!--                    openDelay="300">-->

<!--      </bringoz-icon>-->
<!--      <span class="br-body-1 text-ellipsis">{{ route.totals.totalLoad | bringozWeight:true:'-&#45;&#45;' }}</span>-->
<!--    </div>-->

<!--    &lt;!&ndash;Load - Volume&ndash;&gt;-->
<!--    <div-->
<!--         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"-->
<!--         class="layout-row layout-align-start-center info-row gap-5 text-ellipsis ">-->
<!--      <bringoz-icon iconName="volume"-->
<!--                    classSize="sm"-->
<!--                    [ngbTooltip]="'Volume' | translate"-->
<!--                    openDelay="300">-->

<!--      </bringoz-icon>-->
<!--      <span class="br-body-1 text-ellipsis">{{ route.totals.totalVolume | bringozVolume: true:'-&#45;&#45;' }}</span>-->
<!--    </div>-->

<!--    &lt;!&ndash;Load - Packages&ndash;&gt;-->
<!--    <div-->
<!--         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"-->
<!--         class="layout-row layout-align-start-center info-row gap-5 text-ellipsis ">-->
<!--      <bringoz-icon iconName="package-outline"-->
<!--                    classSize="sm"-->
<!--                    [ngbTooltip]="'Packages' | translate"-->
<!--                    openDelay="300">-->

<!--      </bringoz-icon>-->
<!--      <span-->
<!--        class="br-body-1 text-ellipsis">{{ route.totals.totalPackagesCount === 1 ? 'X_PACKAGE' : 'X_PACKAGES' | translate:{sum: route.totals.totalPackagesCount} }}</span>-->
<!--    </div>-->

<!--    &lt;!&ndash;Load - Value&ndash;&gt;-->
<!--    <div-->
<!--         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"-->
<!--         class=" layout-row layout-align-start-center info-row gap-5 ">-->
<!--      <bringoz-icon iconName="dollar-circle"-->
<!--                    classSize="md"-->
<!--                    fill="#484848"-->
<!--                    [ngbTooltip]="'Value' | translate"-->
<!--                    openDelay="300">-->

<!--      </bringoz-icon>-->
<!--      <span class="br-body-1 text-ellipsis">{{ route.totals?.value | bringozPrice }}</span>-->
<!--    </div>-->

<!--    &lt;!&ndash;Load - Pallets&ndash;&gt;-->
<!--    <div-->
<!--         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"-->
<!--         class=" layout-row layout-align-start-center info-row gap-5 text-ellipsis ">-->
<!--      <bringoz-icon iconName="pallets"-->
<!--                    classSize="sm"-->
<!--                    [ngbTooltip]="'Pallets' | translate"-->
<!--                    openDelay="300">-->

<!--      </bringoz-icon>-->
<!--      <span-->
<!--        class="br-body-1 text-ellipsis">{{ route.totals.totalPallets === 1 ? 'X_PALLET' : 'X_PALLETS' | translate:{sum: route.totals.totalPallets} }}</span>-->
<!--    </div>-->

<!--    &lt;!&ndash;Load - Spots&ndash;&gt;-->
<!--    <div-->
<!--         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"-->
<!--         class=" layout-row layout-align-start-center info-row gap-5 text-ellipsis ">-->
<!--      <bringoz-icon iconName="spot"-->
<!--                    classSize="sm"-->
<!--                    [ngbTooltip]="'Spots' | translate"-->
<!--                    openDelay="300">-->

<!--      </bringoz-icon>-->
<!--      <span-->
<!--        class="br-body-1 text-ellipsis">{{ route.totals.totalSpots === 1 ? 'X_SPOT' : 'X_SPOTS' | translate:{sum: route.totals.totalSpots} }}</span>-->
<!--    </div>-->

<!--    &lt;!&ndash;Load - Income&ndash;&gt;-->
<!--    <div-->
<!--         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"-->
<!--         class=" layout-row layout-align-start-center info-row gap-5 text-ellipsis ">-->
<!--      <bringoz-icon iconName="dollar-circle"-->
<!--                    classSize="sm"-->
<!--                    [ngbTooltip]="'Income' | translate"-->
<!--                    openDelay="300">-->

<!--      </bringoz-icon>-->
<!--      <span class="br-body-1 text-ellipsis route-total-income"-->
<!--            [ngClass]="getTotalIncomeClass(route?.totals?.totalIncome)">{{ route?.totals?.totalIncome | bringozPrice: '-&#45;&#45;' }}</span>-->
<!--    </div>-->

    <!--Capacity Row-->
<!--    <div-->
<!--      *ngIf="(settings.capacity?.weight || settings.capacity?.volume || settings.capacity?.packages || settings.capacity?.spots) && !isCollapsed"-->
<!--      [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"-->

<!--      class=" layout-row layout-align-start-center info-row gap-5 ">-->
<!--      <bringoz-icon iconName="packages"-->
<!--                    classSize="sm"-->
<!--                    fill="#484848"-->
<!--                    [ngbTooltip]="'Capacity' | translate"-->
<!--                    openDelay="300">-->

<!--      </bringoz-icon>-->
<!--      <app-bringoz-primary-capacity class="flex"-->
<!--                                    [weightEnabled]="settings.capacity?.weight"-->
<!--                                    [volumeEnabled]="settings.capacity?.volume"-->
<!--                                    [packagesEnabled]="settings.capacity?.packages"-->
<!--                                    [spotsEnabled]="settings.capacity?.spots"-->
<!--                                    [weight]="route?.totals?.totalLoad"-->
<!--                                    [maxWeight]="route.resource?.capacity?.weight"-->
<!--                                    [volume]="route?.totals?.totalVolume"-->
<!--                                    [maxDimensions]="route.resource?.capacity?.dimensions"-->
<!--                                    [packages]="route?.totals?.totalPackagesCount"-->
<!--                                    [maxPackages]="route.resource?.capacity?.numberOfPackages"-->
<!--                                    [spots]="route?.totals?.totalSpots"-->
<!--                                    [maxSpots]="route.resource?.capacity?.numberOfSpots">-->

<!--      </app-bringoz-primary-capacity>-->

<!--    </div>-->

  </div>

<!--  <div *ngIf="(isHover) && canDrilldown"-->
<!--       class="drill-down-arrow full-height-arrow"-->
<!--       (click)="onDrillDownClick($event)">-->
<!--    <bringoz-icon iconName="arrow-right" classSize="lg" fill="#484848"></bringoz-icon>-->
<!--  </div>-->

</div>
